import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, EmptyComponent, Evidence } from '@eas/common-web';
import { OperationType } from '@models';
import { EvidenceApiUrl } from '@enums';
import { useColumns } from './operation-type-columns';
import { Fields } from './operation-type-fields';

export function OperationTypes() {
  const intl = useIntl();
  const columns = useColumns();

  const evidence = DictionaryEvidence.useDictionaryEvidence<OperationType>({
    version: 2,
    identifier: 'OPERATION_TYPE',
    apiProps: {
      url: EvidenceApiUrl.OPERATION_TYPES,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'ZSD__OPERATION_TYPE__TABLE__TITLE',
        defaultMessage: 'Typy úkonov',
      }),
      showBulkActionButton: false,
      showReportButton: false,
      defaultSorts: [],
    },
    detailProps: {
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ZSD__OPERATION_TYPE__DETAIL__TITLE',
          defaultMessage: 'Typ úkonu',
        }),
        subtitle: (type) => type?.name ?? '',
        showBtn: () => false,
      },
      GeneralFieldsComponent: EmptyComponent,
      FieldsComponent: Fields,
    },
  });

  return <Evidence {...evidence} />;
}
